// hooks/useUserSocket.js
import { useEffect, useCallback } from "react";

export default function useUserSocket(
  socket,
  {
    onUsersAll,        // (users[]) => void
    onUsersNearby,    // (users[]) => void   👈 NEW
    onUsersError,     // (error) => void
  } = {}
) {
  /* ----------------------------------------
     SOCKET LISTENERS
  ---------------------------------------- */
  useEffect(() => {
    if (!socket) return;

    const handleUsersAll = (users) => {
      onUsersAll?.(users);
    };

    const handleUsersNearby = (users) => {
      onUsersNearby?.(users);
    };

    const handleUsersError = (err) => {
      onUsersError?.(err);
    };

    socket.on("users:all", handleUsersAll);
    socket.on("users:nearby", handleUsersNearby);
    socket.on("users:error", handleUsersError);

    return () => {
      socket.off("users:all", handleUsersAll);
      socket.off("users:nearby", handleUsersNearby);
      socket.off("users:error", handleUsersError);
    };
  }, [socket, onUsersAll, onUsersNearby, onUsersError]);

  /* ----------------------------------------
     REQUEST ALL USERS (LEGACY / INTERNAL)
  ---------------------------------------- */
  const getAllUsers = useCallback(() => {
    if (!socket) return;
    socket.emit("users:get-all");
  }, [socket]);

  /* ----------------------------------------
     REQUEST NEARBY USERS (IP-BASED)
  ---------------------------------------- */
  const getNearbyUsers = useCallback(() => {
    if (!socket) return;
    socket.emit("users:get-nearby-ip");
  }, [socket]);

  return {
    getAllUsers,
    getNearbyUsers, // 👈 NEW
  };
}
